import { c as _c } from "react/compiler-runtime";
interface IconProps {
  className?: string;
  stroke?: string;
}

/**
 * Chat bubble icon
 */
export function ChatIcon(t0) {
  const $ = _c(4);
  const {
    className: t1,
    stroke: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const stroke = t2 === undefined ? "currentColor" : t2;
  const t3 = `pointer-events-none ${className}`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path strokeLinecap="round" strokeLinejoin="round" d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.159 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z" />;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== stroke || $[2] !== t3) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke={stroke} className={t3}>{t4}</svg>;
    $[1] = stroke;
    $[2] = t3;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  return t5;
}

/**
 * Close/X icon
 */
export function CloseIcon(t0) {
  const $ = _c(4);
  const {
    className: t1,
    stroke: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const stroke = t2 === undefined ? "currentColor" : t2;
  const t3 = `pointer-events-none ${className}`;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />;
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== stroke || $[2] !== t3) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke={stroke} className={t3}>{t4}</svg>;
    $[1] = stroke;
    $[2] = t3;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  return t5;
}